import { render, staticRenderFns } from "./ProductBtnTablet.vue?vue&type=template&id=52c51034&"
import script from "./ProductBtnTablet.vue?vue&type=script&lang=js&"
export * from "./ProductBtnTablet.vue?vue&type=script&lang=js&"
import style0 from "./ProductBtnTablet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports